export const EVENT_REFERRAL_EMAIL_SENT = 'referral.email'
